import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-multiselect-wrapper',
  template: `
    <div>
      <label>{{ props.label }}</label>
      <p-multiSelect
        [formControl]="$any(formControl)"
        [options]="selectOptions"
        [placeholder]="props.placeholder"
        [optionLabel]="optionLabel"
        [dataKey]="dataKey || undefined"
      ></p-multiSelect>
    </div>
  `
})
export class MultiselectWrapperComponent extends FieldType implements OnInit {
  searchConfig!:
    | {
        optionLabel: string;
        dataKey: string;
      }
    | undefined;
  selectOptions: any[] | undefined = [];
  optionLabel: string | undefined = '';
  dataKey: string | undefined = '';

  ngOnInit() {
    this.selectOptions = this.props.options as any[] | undefined;
    this.searchConfig = this.props['searchConfig'];
    this.optionLabel = this.searchConfig?.optionLabel;
    this.dataKey = this.searchConfig?.dataKey;
    if (!this.props.options) {
      this.props.options = [];
    }
  }
}
